export default __webpack_public_path__ + "dfe47db0bc480fbbe7ebf5bf74912a24.png";